import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe822cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-wrap" }
const _hoisted_2 = { class: "footer-content m-t-38" }
const _hoisted_3 = { class: "top flex justify-between" }
const _hoisted_4 = { class: "left flex" }
const _hoisted_5 = { class: "level-first w-64 h-22 l-h-22 f-w-500 col-b-white f-s-16 m-b-23" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "f-s-22 col-b-white h-30 l-h-30 m-b-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-12 f-w-400 white-opacity h-17 l-h-17 m-b-50" }, "工作日：08:30 - 18:00", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-12 f-w-400 h-17 l-h-17 white-opacity text-center" }, "微信公众号", -1))
const _hoisted_12 = { class: "bottom f-s-12 f-w-400 l-h-45 white-opacity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "nav-item",
              key: item.route
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "level-second f-s-12 f-w-400 m-b-20 pointer white-opacity",
                  key: index,
                  onClick: ($event: any) => (_ctx.handleNavLinkClick(item, child))
                }, _toDisplayString(child.name), 9, _hoisted_6))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.phoneOf400), 1),
          _hoisted_9,
          _createElementVNode("img", {
            src: _ctx.qrcodeUrl,
            class: "h-158 m-b-6"
          }, null, 8, _hoisted_10),
          _hoisted_11
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(" Copyright @ 2006-" + _toDisplayString(_ctx.currentYear) + " ETAH Inc. All Rights Reserved. 东信同邦 版权所有 ", 1),
        _createElementVNode("span", {
          class: "pointer network-check",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
        }, "鄂ICP备19003607号-1")
      ])
    ])
  ]))
}